module.exports = __webpack_public_path__ + "img/qd-img-7.6d9bb99c.png";